import { loadModal } from '../../../AsyncLoader';
import dom from '../../../utils/dom';


export async function getUserConfirmation($trigger, { title, body, okButton, cancelButton }) {
  const Modal = await loadModal();

  return new Promise((resolve) => {
    Modal.confirm({
      title,
      bodyContents: body,
      labelBtnConfirm: okButton,
      labelBtnCancel: cancelButton,
      returnFocusTo: $trigger,
      onConfirm: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
}


export async function showSeatingRequestsModal($trigger, value, config) {
  const Modal = await loadModal();

  const { sectionSubHead, sectionText, cancelButtonLabel, submitButtonLabel } = config;

  const INPUT_ID = 'tn-input-seating-request-notes';

  const $contents = dom.parseElement(`
    <div class="tn-flex-seating-notes-form">
      <label for="${INPUT_ID}">Seating Request Notes</label>
      <div class="tn-flex-seating-notes-form__details">${sectionText}</div>
      <textarea id="${INPUT_ID}" class="form-control tn-flex-seating-notes-form__textarea" rows="8">${value}</textarea>
    </div>
  `);

  const $input = dom.findFrom($contents, `#${INPUT_ID}`);

  return new Promise((resolve) => {
    Modal.confirm({
      title: sectionSubHead,
      bodyContents: $contents,
      returnFocusTo: $trigger,
      labelBtnConfirm: submitButtonLabel,
      labelBtnCancel: cancelButtonLabel,
      onConfirm: () => resolve($input.value),
      onCancel: () => resolve(null),
    });
  });
}



// WEBPACK FOOTER //
// ./V7/packages/flex/selections/FlexModals.js